// extracted by mini-css-extract-plugin
export default {"container":"checkout_container__w6kpS","address":"checkout_address__qBwf+","title":"checkout_title__zwGlV"};